import { formatHour } from "../constants/constants";
import { CheckRead } from "../icons/CheckRead";
import { Loading } from "../icons/Loading";
import { ReadingMessage, ReadMessage } from "../icons/Read";
import { TimePending } from "../icons/Time";
import { CircleNumber } from "./CircleNumber";
import { Column } from "./Column";
import { TextComponent } from "./TextComponent";

interface ChatMessagesProps {
    variant: string;
    message: string |JSX.Element;
    hour: string;
    read: boolean;
    type: string;
    is_temp: boolean;
    isOpenTemp?: () => void;
    handleOpenImage?: () => void;
    loading?: boolean;
}

export const ChatMessages = ({ variant, message, hour, read, type, is_temp, isOpenTemp, handleOpenImage, loading}: ChatMessagesProps) => {
    return (
        <Column
            className={`relative min-w-20 max-w-[27rem] shadow-lg p-4 max-md:pb-5 md:p-5 rounded-2xl ${variant === "send"
                ? "self-end bg-primary rounded-br-none text-white"
                : "self-start bg-white rounded-bl-none text-black"}`}
        >
            {(type === "image" || type === "file") && typeof message === "string"  ?
                <>
                    {is_temp ?
                        <>
                            {variant === "send"  ? 
                                <TextComponent variant="h6" className="font-semibold flex items-center gap-0.5">
                                    {message === "" ?  
                                        <> 
                                            <CheckRead className="w-4 h-4 md:w-5 md:h-5" /> Opened 
                                        </> 
                                    : 
                                        <>
                                            <CircleNumber className="w-4 h-4 md:w-5 md:h-5" /> Photo
                                        </>
                                    }
                                </TextComponent>
                                : 
                                <>
                                    {message === "" ? 
                                        <TextComponent variant="h6" className="font-semibold flex gap-0.5">
                                            <CheckRead /> Opened
                                        </TextComponent>
                                        :
                                        <button onClick={isOpenTemp}>
                                            <TextComponent variant="h6" className="font-semibold flex gap-0.5">
                                                <TimePending className="w-5 h-5" strokeWidth="2" /> Click to open
                                            </TextComponent>
                                        </button>
                                    }
                                </>
                            }
                        </>
                        :
                        <>
                            {loading ? (
                                <div className="relative select-none overflow-hidden">
                                    <img 
                                        src={message} 
                                        alt={message} 
                                        draggable={false} 
                                        className="select-none h-[22.5rem] w-[22.5rem] object-cover blur-sm" 
                                    />
                                    <Loading className="w-20 h-20 absolute z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" strokeWidth="5" />
                                </div>
                            ) : (
                                <img 
                                    src={message} 
                                    alt={message} 
                                    draggable={false} 
                                    className="select-none h-[22.5rem] w-[22.5rem] object-cover cursor-pointer" 
                                    onClick={handleOpenImage} 
                                />
                            )}
                        </>
                    }
                </>
                :
                <TextComponent
                    variant="nh6"
                    className="max-w-[22.5rem] break-all whitespace-pre-wrap"
                >
                    {message}
                </TextComponent>
            }
            <TextComponent
                className={`flex w-12 justify-end gap-0.5 text-end absolute bottom-1 items-center right-2 select-none ${variant !== "send" && "text-graySecondary"}`}
                variant="nh8"
            >
                {variant === "send" && (read ? (<ReadMessage />) : (!loading ?  (<ReadingMessage />) : <TimePending className="w-3.5" />))} {formatHour(hour)}
            </TextComponent>
        </Column>
    )
}